"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllFormatters = exports.getColumnFormatter = exports.registerFormatter = exports.getFormatterFactory = void 0;
const _ = __importStar(require("lodash"));
__exportStar(require("./badge"), exports);
__exportStar(require("./bool"), exports);
__exportStar(require("./cellclass"), exports);
__exportStar(require("./chain"), exports);
__exportStar(require("./checkbox"), exports);
__exportStar(require("./clicksink"), exports);
__exportStar(require("./command"), exports);
__exportStar(require("./date"), exports);
__exportStar(require("./datetime"), exports);
__exportStar(require("./filesize"), exports);
__exportStar(require("./getvalue"), exports);
__exportStar(require("./join"), exports);
__exportStar(require("./jsonify"), exports);
__exportStar(require("./link"), exports);
__exportStar(require("./mapvalue"), exports);
__exportStar(require("./template"), exports);
__exportStar(require("./text"), exports);
__exportStar(require("./time"), exports);
const badge_1 = require("./badge");
const bool_1 = require("./bool");
const cellclass_1 = require("./cellclass");
const chain_1 = require("./chain");
const checkbox_1 = require("./checkbox");
const clicksink_1 = require("./clicksink");
const command_1 = require("./command");
const date_1 = require("./date");
const datetime_1 = require("./datetime");
const filesize_1 = require("./filesize");
const getvalue_1 = require("./getvalue");
const join_1 = require("./join");
const jsonify_1 = require("./jsonify");
const link_1 = require("./link");
const mapvalue_1 = require("./mapvalue");
const template_1 = require("./template");
const text_1 = require("./text");
const time_1 = require("./time");
const ALL = {
    badge: badge_1.badge,
    bool: bool_1.bool,
    cellclass: cellclass_1.cellclass,
    chain: chain_1.chain,
    checkbox: checkbox_1.checkbox,
    clicksink: clicksink_1.clicksink,
    command: command_1.command,
    date: date_1.date,
    datetime: datetime_1.datetime,
    filesize: filesize_1.filesize,
    getvalue: getvalue_1.getvalue,
    join: join_1.join,
    jsonify: jsonify_1.jsonify,
    link: link_1.link,
    mapvalue: mapvalue_1.mapvalue,
    template: template_1.template,
    text: text_1.text,
    time: time_1.time
};
function getFormatterFactory(name) {
    const result = ALL[name];
    if (!result) {
        throw new TypeError(`invalid column formatter name: ${name}`);
    }
    return result;
}
exports.getFormatterFactory = getFormatterFactory;
function registerFormatter(name, factory) {
    if (ALL[name]) {
        throw new Error(`Formatter already exists: ${name}`);
    }
    ALL[name] = factory;
}
exports.registerFormatter = registerFormatter;
function getColumnFormatter(column) {
    if (_.isString(column.formatter)) {
        return getFormatterFactory(column.formatter)({});
    }
    if (!_.isFunction(column.formatter) && _.isArray(column.formatter)) {
        return (0, chain_1.chain)({ formatters: column.formatter });
    }
    if (!_.isFunction(column.formatter) && _.isObject(column.formatter)) {
        return getFormatterFactory(column.formatter['name'])(column.formatter);
    }
    if (column.formatter == null) {
        return getDefaultFormatter(column);
    }
    return column.formatter;
}
exports.getColumnFormatter = getColumnFormatter;
function getDefaultFormatter(column) {
    if (column.type === 'date-time' || column.format === 'date-time') {
        return (0, datetime_1.datetime)({});
    }
    return column.formatter;
}
function getAllFormatters() {
    return { ...ALL };
}
exports.getAllFormatters = getAllFormatters;
//# sourceMappingURL=index.js.map